export function submitAddCustomerProduct()
{
    return({
        type:"SUBMIT_ADD_CUSTOMER_PRODUCT"
    })
}